import { Avatar, IconButton, useTranslation, useTranslationRoute, useUserProfilePicture } from "@bsm/component";
import { TUserStudentFamilyRelation } from "@bsm/graphql";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useStudentDetailsQuery } from "../hooks/useStudentDetailsQuery";

export const UserStudentItem = (props: Partial<TUserStudentFamilyRelation>) => {

    const t = useTranslation()
    const tr = useTranslationRoute()
    const profilePictureUrl = useUserProfilePicture()

    const link = useMemo(() => props.student?.id ? tr(`admin/students/${props?.student?.id}`) : '#', [props])

    const hasStudentData = useMemo(() => !!props.student?.user?.fullName, [props?.student?.user])
    const { data } = useStudentDetailsQuery(!hasStudentData ? props.student?.id : undefined, true);

    if(data?.isEnrolled) {
        return <></>
    }

    const student = useMemo(() => {
        if(!hasStudentData) return data
        return props.student
    }, [data, props?.student?.user])

    return (
        <div className="flex items-center justify-between w-full pt-2 pb-4 border-default border-b">
            <div className="flex items-center gap-4">
                <Link to={link} target="_blank">
                    <Avatar
                        src={profilePictureUrl(student?.user?.id)}
                        size="md"
                    />
                </Link>
                <div className="flex flex-col">
                    <Link to={link} target="_blank">
                        <h5 className="font-semibold mb-0">{student?.user?.fullName}</h5>
                    </Link>
                    <div>
                        <p>
                            {t(`Bsm.Invoice.User.Student.Family.Members.${props.type}.Label`)}
                        </p>
                    </div>
                </div>
            </div>

            {
                hasStudentData &&
                <Link
                    to={link}
                >
                    <IconButton icon="fa-solid fa-angle-right" />
                </Link>
            }
        </div>
    )

}

